// frontend/admin-portal/src/components/settings/sections/FinanceSettings.jsx
import React from "react";
import SettingItem from "../items/SettingItem";
import TextInput from "../items/TextInput";
import NumberInput from "../items/NumberInput";
import ToggleSwitch from "../items/ToggleSwitch";

export default function FinanceSettings({ values = {}, onChange }) {
  const set = (k, v) => typeof onChange === "function" && onChange(k, v);
  return (
    <div className="fh-settings-list">
      <SettingItem label="Currency Code">
        <TextInput
          value={values["finance.currency"]}
          onChange={(v) => set("finance.currency", v)}
        />
      </SettingItem>
      <SettingItem label="Currency Symbol">
        <TextInput
          value={values["finance.currencySymbol"]}
          onChange={(v) => set("finance.currencySymbol", v)}
        />
      </SettingItem>
      <SettingItem label="Decimal Places">
        <NumberInput
          value={values["finance.currencyDecimals"]}
          onChange={(v) => set("finance.currencyDecimals", v)}
          min={0}
          max={4}
        />
      </SettingItem>
      <SettingItem label="Enable Tax">
        <ToggleSwitch
          checked={values["finance.taxEnabled"]}
          onChange={(v) => set("finance.taxEnabled", v)}
        />
      </SettingItem>
      <SettingItem label="Tax Rate (%)">
        <NumberInput
          value={values["finance.taxRate"]}
          onChange={(v) => set("finance.taxRate", v)}
          min={0}
          max={100}
          step={0.1}
        />
      </SettingItem>
      <SettingItem label="Prices Include Tax">
        <ToggleSwitch
          checked={values["finance.taxInclusive"]}
          onChange={(v) => set("finance.taxInclusive", v)}
        />
      </SettingItem>
      <SettingItem label="Invoice Prefix">
        <TextInput
          value={values["finance.invoicePrefix"]}
          onChange={(v) => set("finance.invoicePrefix", v)}
        />
      </SettingItem>
      <SettingItem label="Invoice Footer Text">
        <TextInput
          value={values["finance.invoiceFooter"]}
          onChange={(v) => set("finance.invoiceFooter", v)}
        />
      </SettingItem>
    </div>
  );
}
